import styled from '@benzinga/themetron';

export const TooltipButton = styled.div`
  align-items: center;
  align-self: center;
  background-color: transparent;
  border: 0;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  font-size: 1.25em;
  justify-content: center;
  outline: none;
  padding: 0;
  height: 100%;
  > {
    padding: 0 8px;
  }
`;
